module.exports = __webpack_public_path__ + "img/5.7ea420e7.jpg";